import React, { useState } from "react";
import { Button, Checkbox,  Chip,  FormControl,  FormControlLabel,  FormGroup,  IconButton,  InputLabel, MenuItem,  Popover,  Select,  TextField,  Tooltip, } from "@mui/material";
import { FilterAltOutlined, Close as CloseIcon } from "@mui/icons-material";
import styled from "styled-components";

const ChipContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: start;
  margin-top: 8px;
  flex-wrap: wrap;
`

interface FilterableTextFieldProps {
    uniqueActives: string[];
    previouslySelectedFilters?: string[];
    filter: string;
    setFilter: (text: string) => void;
    filterKey: string;
    setFilterKey: (val: string) => void;
    onApplyFilters: (selectedFilters: string[]) => void;
}

export const FilterableTextField: React.FC<FilterableTextFieldProps> = ({ uniqueActives, previouslySelectedFilters, filter, setFilter, filterKey, setFilterKey, onApplyFilters }) => {
    const [anchorEl, setAnchorEl] = useState<null|HTMLElement>(null);
    const [selectedFilters, setSelectedFilters] = useState<string[]>(previouslySelectedFilters||[]);
    const [tempSelectedFilters, setTempSelectedFilters] = useState<string[]>([]);

    const handleFilterClick = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget);
        setTempSelectedFilters(selectedFilters);
    };

    const handleFilterClose = () => {
        setAnchorEl(null);
    };

    const handleFilterChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const value = event.target.name;
        const updatedFilters = tempSelectedFilters.includes(value)
            ? tempSelectedFilters.filter((filter) => filter !== value)
            : [...tempSelectedFilters, value];
        setTempSelectedFilters(updatedFilters);
    };

    const handleChipDelete = (chipToDelete: string) => {
        const updatedFilters = selectedFilters.filter((chip) => chip !== chipToDelete);
        setSelectedFilters(updatedFilters);
        onApplyFilters(updatedFilters);
    };

    const handleApplyFilters = () => {
        setSelectedFilters(tempSelectedFilters);
        onApplyFilters(tempSelectedFilters);
        handleFilterClose();
    };

    const open = Boolean(anchorEl);
    const id = open ? "filter-popover" : undefined;

    return (
        <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
            <div style={{ display: "flex", gap: "8px", marginTop: "5px" }}>
                <FormControl style={{ flex: "0 0 200px" }}>
                    <InputLabel id="filter-key-label">Filtrar por</InputLabel>
                        <Select
                            value={filterKey}
                            label="Filtrar por"
                            onChange={(e) => setFilterKey(e.target.value)}
                            style={{ height: "100%" }}
                        >
                            <MenuItem value="name">Nome</MenuItem>
                            <MenuItem value="classifications">Classificações</MenuItem>
                            <MenuItem value="userClassifications">Classificações do usuário</MenuItem>
                            <MenuItem value="annotation">Anotação</MenuItem>
                        </Select>
                </FormControl>

            <TextField
                style={{ width: "100%" }}
                label="Buscar..."
                variant="outlined"
                value={filter}
                onChange={(e) => setFilter(e.target.value)}
                InputProps={{
                    startAdornment: (
                        <Tooltip title="Filtrar" placement="top">
                            <IconButton onClick={handleFilterClick} color="secondary">
                                <FilterAltOutlined />
                            </IconButton>
                        </Tooltip>
                    ),
                endAdornment: !!filter && (
                    <Tooltip title="Limpar" placement="top">
                        <IconButton onClick={() => setFilter("")}>
                            <CloseIcon fontSize="small" />
                        </IconButton>
                    </Tooltip>
                    )
                }}
            />
        </div>

            {selectedFilters.length > 0 && (
                <ChipContainer>
                    {selectedFilters.map((filter) => (
                        <Chip
                            key={filter}
                            size="small"
                            label={filter}
                            variant="filled"
                            color={"primary"}
                            onDelete={() => handleChipDelete(filter)}
                            style={{ marginRight: "16px", marginTop: "8px" }}
                        />
                    ))}
                </ChipContainer>
            )}
            <Popover
                id={id}
                open={open}
                anchorEl={anchorEl}
                onClose={handleFilterClose}
                anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "left",
                }}
            >
                <FormGroup sx={{ padding: "8px" }}>
                    {uniqueActives.map((active) => (
                        <FormControlLabel
                            key={active}
                            control={
                                <Checkbox
                                    checked={tempSelectedFilters.includes(active)}
                                    onChange={handleFilterChange}
                                    name={active}
                                />
                            }
                            label={active}
                        />
                    ))}
                    <Button
                        variant="contained"
                        color="secondary"
                        onClick={handleApplyFilters}
                        sx={{ marginTop: "8px" }}
                    >
                        Aplicar filtros
                    </Button>
                </FormGroup>
            </Popover>
        </div>
    );
};